import {useRoutes} from "react-router-dom";
import {LoadComponent} from "@loadComponent";
import {lazy} from "react";
import {$subTitle} from "_layout/Client/Header";

const Search = lazy(() => import('./Search'));
const List = lazy(() => import('./List'));
const CourtHearingsCalendar = lazy(() => import('./pages/CourtHearingsCalendar'));

const Home = () => {
    $subTitle.set('Audiências');
    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={Search}/>
        },
        {
            path: 'varas',
            element: <LoadComponent component={List}/>
        },
        {
            path: 'agenda/:courtId',
            element: <LoadComponent component={CourtHearingsCalendar}/>
        },
    ]);
};


export default Home;
